import SelectInput from '@atoms/Inputs/SelectInput';
import { LOCALES } from '@constants/constants';
import useLocale from '@hooks/useLocale';
import useStore from '@hooks/useStore';
import { Locale } from '@type-declarations/prepr';
import { setCookie } from '@utils/clientCookies';
import getInternalRoute from '@utils/getInternalRoute';
import { Language } from 'iconoir-react';
import { useRouter } from 'next/router';
import { ChangeEvent } from 'react';

interface Props {
  id: string;
}

const options = [
  {
    label: 'Nederlands',
    value: 'nl',
  },
  {
    label: 'English',
    value: 'en',
  },
];

const label = {
  nl: 'Selecteer een taal',
  en: 'Select a language',
};

export default function LanguageSwitch({ id }: Props) {
  const locale = useLocale();

  const {
    store: { page },
    setStore,
  } = useStore();

  const { push } = useRouter();

  const handleSelect = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value as Locale;
    const localization = page?.localizations?.find(
      loc => loc.locale === LOCALES[value],
    );

    /* Redirect to homepage if no localization for selected language is available */
    const route = localization
      ? getInternalRoute({
          internalLink: {
            ...localization,
            typename: page!.typename,
            category: page!.category,
          },
          locale: value,
        })
      : '/';

    setCookie('NEXT_LOCALE', value);
    setStore(store => ({ ...store, locale: value }));
    push(route, undefined, { locale: value });
  };

  return (
    <SelectInput
      id={id}
      withShadow
      value={locale}
      Icon={Language}
      options={options}
      onChange={handleSelect}
      label={label[locale] || label.nl}
      colorVariant="lightGray"
    />
  );
}
